import event0 from "../images/events/flag.svg";
import event1 from "../images/events/meetingPoint.svg";
import event2 from "../images/events/closed.svg";
import event3 from "../images/events/crash.svg";
import event4 from "../images/events/criminal.svg";
import event5 from "../images/events/fire.svg";
import event6 from "../images/events/construction.svg";
import event7 from "../images/events/flood.svg";
import event8 from "../images/events/landslides.svg";
import event9 from "../images/events/protest.svg";

export const eventsImages = {
  v0: { id: 0, svg: event0, title: "flag", details: "flagDetails" },
  v1: {
    id: 1,
    svg: event1,
    title: "meetingPoint",
    details: "meetingPointDetails",
    // name: true,
  },
  v2: {
    id: 2,
    svg: event2,
    title: "closedStreet",
    details: "closedStreetDetails",
  },
  v3: { id: 3, svg: event3, title: "crash", details: "crashDetails" },
  v4: {
    id: 4,
    svg: event4,
    title: "criminal",
    details: "criminalDetails",
  },
  v5: { id: 5, svg: event5, title: "fire", details: "fireDetails" },
  v6: {
    id: 6,
    svg: event6,
    title: "construction",
    details: "constructionDetails",
  },
  v7: { id: 7, svg: event7, title: "flood", details: "floodDetails" },
  v8: {
    id: 8,
    svg: event8,
    title: "landslides",
    details: "landslidesDetails",
  },
  v9: {
    id: 9,
    svg: event9,
    title: "protest",
    details: "protestDetails",
  },
};

export const eventsRows = [
  [
    eventsImages.v0,
    eventsImages.v1,
    eventsImages.v2,
    eventsImages.v3,
    eventsImages.v4,
  ],
  [
    eventsImages.v5,
    eventsImages.v6,
    eventsImages.v7,
    eventsImages.v8,
    eventsImages.v9,
  ],
];
